export default "__VITE_ASSET__Ci0vzHsK__"